<template>
  <v-row justify="center">
    <v-col md="8">
      <h2 class="display-2 text-center py-6">An Error Occurred.</h2>
      <h3 class="display-1 text-center py-6">Please refresh the page.</h3>
      <h4 class="text-center py-3">If that doesn't work, please contact the website maintainer.</h4>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "AppError",
  }
</script>

<style scoped></style>
